KCVS.Views.ReportInvoiceRowsTable =
  template: JST['report_rows/invoice_rows_table']()
  store: KCVS.Stores.ReportRowsStore
  mounted: ->
    @$store.dispatch('fetchInvoiceRows')

  data: ->
    iceboxingReason: ''
    iceboxReasonModalOpen: false
    processing: false

  components:
    'informative-tooltip': KCVS.Views.InformativeTooltip

  computed:
    applicable_sum: ->
      _.reduce(@rows, ((memo, row)-> memo + parseFloat row.applicable_amount), 0.00)

    allRowsSelected:
      get: ->
        @$store.state.selectedInvoiceRowIds.length == @$store.state.invoiceRows.length
      set: (val) ->
        if val
          @$store.commit('selectAllInvoiceRows')
        else
          @$store.commit('deselectAllInvoiceRows')

    rows: ->
      @$store.state.invoiceRows

    showMoveToIceboxButton: ->
      @$store.state.selectedInvoiceRowIds.length > 0

    readOnly: ->
      return @$store.state.periodClosed

  methods:
    openModal: ->
      @iceboxReasonModalOpen = true

    closeModal: ->
      @iceboxReasonModalOpen = false

    moveToIcebox: ->
      return if @processing # don't run request twice if button is quickly pressed more than once
      @processing = true
      @$store.dispatch('moveSelectedRowsToIcebox', @iceboxingReason)
      .then(() =>
        @iceboxingReason = ''
        @closeModal()
      )
